import { isNumber } from '@anton.bobrov/react-hooks';
export function getHorizontalAlignmentStyles(_a) {
    var alignment = _a.alignment, domRect = _a.domRect, gapProp = _a.gap, viewportGapProp = _a.viewportGap, viewportRef = _a.viewportRef;
    if (!domRect) {
        return undefined;
    }
    var gap = isNumber(gapProp) ? gapProp : gapProp();
    var viewportGap = isNumber(viewportGapProp)
        ? viewportGapProp
        : viewportGapProp();
    var viewportWidth = document.documentElement.clientWidth;
    var viewportElement = viewportRef === null || viewportRef === void 0 ? void 0 : viewportRef.current;
    var viewportRect = viewportElement
        ? viewportElement.getBoundingClientRect()
        : {
            left: 0,
            width: viewportWidth,
            right: viewportWidth,
        };
    if (alignment === 'start') {
        var left = domRect.left;
        var maxWidth = viewportRect.right - left - viewportGap;
        return {
            left: "".concat(left, "px"),
            right: 'auto',
            x: '0',
            maxWidth: "".concat(maxWidth, "px"),
        };
    }
    if (alignment === 'center') {
        var maxWidth = Math.min(domRect.left + domRect.width / 2 - viewportRect.left, viewportRect.right - (domRect.left + domRect.width / 2)) *
            2 -
            viewportGap * 2;
        return {
            left: "".concat(domRect.left + domRect.width / 2, "px"),
            right: 'auto',
            x: '-50%',
            maxWidth: "".concat(maxWidth, "px"),
        };
    }
    if (alignment === 'end') {
        var right = viewportWidth - domRect.right;
        var maxWidth = domRect.right - viewportRect.left - viewportGap;
        return {
            left: 'auto',
            right: "".concat(right, "px"),
            x: '0',
            maxWidth: "".concat(maxWidth, "px"),
        };
    }
    if (alignment === 'left') {
        var right = viewportWidth - domRect.left + gap;
        var maxWidth = domRect.left - viewportRect.left - gap - viewportGap;
        return {
            left: 'auto',
            right: "".concat(right, "px"),
            x: '0',
            maxWidth: "".concat(maxWidth, "px"),
        };
    }
    if (alignment === 'right') {
        var left = domRect.right + gap;
        var maxWidth = viewportRect.right - domRect.right - gap - viewportGap;
        return {
            left: "".concat(left, "px"),
            right: 'auto',
            x: '0',
            maxWidth: "".concat(maxWidth, "px"),
        };
    }
    return undefined;
}
//# sourceMappingURL=getHorizontalAlignmentStyles.js.map